import Vue from 'vue'

export default {
  all () {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/affiliated_groups`
    )
  },
  findById (id) {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/affiliated_groups/${id}`
    )
  }
}
